/* StarringYou — tunnel (section sy-funnel). Config dans #sy-cfg, suivi via SYTrack (sy-track.js). */
(() => {
  const $ = (id) => document.getElementById(id);
  const CFG = JSON.parse($('sy-cfg').textContent);
  const ICON = (k) => { const el = document.querySelector(`#syIcons`).content.querySelector(`[data-i="${k}"]`); return el ? el.innerHTML : ''; };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
  const list = (s) => String(s || '').split(',').map((x) => x.trim()).filter(Boolean);
  const cap = (s) => s.replace(/["'’`]+/g, '').trim().replace(/\s+/g, ' ').replace(/(^|[\s-])(\p{L})/gu, (m, a, b) => a + b.toUpperCase());
  const money = (cents) => {
    const v = cents / 100;
    try { return new Intl.NumberFormat('en-US', {style: 'currency', currency: CFG.currency || 'USD', minimumFractionDigits: Number.isInteger(v) ? 0 : 2}).format(v); }
    catch (e) { return '$' + v; }
  };
  const track = (n, name, data) => { try { SYTrack.step(n, name, data); } catch (e) {} };
  const evt = (name, data) => { try { SYTrack.event(name, data); } catch (e) {} };

  CFG.adventures.push({key: 'custom', name: 'Your own world', slug: 'custom', title_boy: '{name} and the Secret World', title_girl: '{name} and the Secret World', line: 'I\u2019m {name}, let\u2019s explore!', quest: '{name} discovers a brand-new world', img_boy: '', img_girl: '', color: 'c1'});
  const NAMES = {1: 'hero', 2: 'world', 3: 'photo', 4: 'sidekicks', 5: 'passions', 6: 'occasion', 7: 'stories', 8: 'creating', 9: 'preview', 10: 'pack'};
  const MK = 8, PV = 9, LAST = 10;
  const STEPS = [1, 2, 3, 6, 8, 9, 10];
  const d = {g: '', adv: '', friend: false, fg: '', hair: '', pet: false, petType: '', color: '', pack: Math.min(Math.max(CFG.popular, 0), CFG.variants.length - 1), addons: {}, file: null, thumb: '', story: null};
  let step = 1, leadSent = false;

  /* ---------- helpers de texte ---------- */
  const name = () => cap($('syName').value) || 'your hero';
  const adv = () => CFG.adventures.find((a) => a.key === d.adv);
  const his = () => (d.g === 'girl' ? 'her' : d.g === 'boy' ? 'his' : 'their');
  const fill = (s) => {
    const a = adv();
    return String(s || '')
      .replace(/\{name\}/g, name())
      .replace(/\{His\}/g, d.g === 'girl' ? 'Her' : 'His')
      .replace(/\{adventure\}/g, a ? a.name.toLowerCase() : 'adventure')
      .replace(/\{friend\}/g, d.friend && $('syFriendName').value.trim() ? cap($('syFriendName').value) : 'a friend')
      .replace(/\{pet\}/g, d.pet && $('syPetName').value.trim() ? cap($('syPetName').value) : 'a pet');
  };
  const heroTitle = () => { const a = adv(); return a ? fill(d.g === 'girl' ? a.title_girl : a.title_boy) : name(); };
  function texts() {
    document.querySelectorAll('[data-t]').forEach((el) => { el.textContent = fill(el.dataset.t); });
  }

  /* ---------- choix simples ---------- */
  const single = (wrap, cb) => wrap.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    wrap.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    cb(b.dataset.v, b); $('syErr').textContent = '';
  });
  single($('syGender'), (v) => { d.g = v; swapImgs(); });
  single($('syFriendGender'), (v) => { d.fg = v; });

  /* âge → niveau d'histoire (comme lepetitheros : éveil / imaginaire / exploration / aventure) */
  const STAGES = [
    {max: 2, t: 'Awakening', d: 'A reassuring world, full of colors and images, to awaken the senses.'},
    {max: 5, t: 'Imagination', d: 'Gentle adventures that feed the imagination.'},
    {max: 8, t: 'Exploration', d: 'Stories full of discoveries that spark curiosity and courage.'},
    {max: 12, t: 'Adventure', d: 'Bold, action-packed quests for brave big kids.'},
  ];
  const stageOf = (v) => STAGES.findIndex((x) => v <= x.max);
  let ageSet = true;  // 11/10 (Kais) : l'âge n'est plus obligatoire, 4 ans par défaut accepté sans toucher au curseur
  function ageUI() {
    const v = +$('syAge').value, i = stageOf(v);
    $('syAge').closest('.agex').classList.toggle('agex--unset', !ageSet);
    $('syAgeOut').textContent = !ageSet ? 'Slide to set the age' : v === 0 ? 'Newborn' : v + (v > 1 ? ' years' : ' year');
    $('syAge').style.setProperty('--fill', (v / 12) * 100 + '%');
    $('syStages').querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.st === i)));
    $('syStageT').textContent = STAGES[i].t; $('syStageD').textContent = STAGES[i].d;
    $('syStageIco').innerHTML = $('syStages').querySelector(`[data-st="${i}"]`).querySelector('svg').outerHTML;
  }
  $('syAge').addEventListener('input', () => { ageSet = true; ageUI(); });
  // les boutons de niveau n'écrasent PLUS l'âge (08/10 : « Adventure » mettait 10 ans à un enfant de 6) : le niveau suit l'âge, c'est tout
  $('syStages').addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; $('syAge').focus(); $('syErr').textContent = 'Set the age with the slider: the story level follows it.'; });
  ageUI();
  ['syName', 'syFriendName', 'syPetName'].forEach((id) => $(id).addEventListener('blur', () => { $(id).value = cap($(id).value); }));
  $('syName').addEventListener('input', () => { $('syName').classList.toggle('ok', $('syName').value.trim().length > 1); });
  $('syEmail').addEventListener('input', () => { $('syEmail').classList.toggle('ok', validEmail()); });
  const validEmail = () => /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test($('syEmail').value.trim());

  /* aventures */
  $('syAdv').addEventListener('click', (e) => {
    const b = e.target.closest('.adv'); if (!b) return;
    $('syAdv').querySelectorAll('.adv').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    d.adv = b.dataset.key; $('syErr').textContent = ''; $('syWorld').classList.remove('on');
    evt('sy_adventure', {adventure: (adv() || {}).slug});
    setTimeout(() => { if (step === 2) go(3); }, 350);
  });
  function swapImgs() {
    try { worldChips(); } catch (e) {}  // pas encore prêt au tout premier chargement
    document.querySelectorAll('#syAdv img[data-boy]').forEach((im) => { im.src = d.g === 'girl' ? im.dataset.girl : im.dataset.boy; });
    // carte réservée à un sexe : Spider Boy à la place de Princess chez les garçons (Kais 2026-10-11)
    const g = d.g === 'girl' ? 'girl' : 'boy';
    $('syAdv').querySelectorAll('.adv[data-for]').forEach((b) => {
      const f = b.dataset.for || 'all', show = f === 'all' || f === g;
      b.hidden = !show;
      const pop = b.dataset.pop || 'none'; b.classList.toggle('is-pop', pop === 'all' || pop === g);   // badge « Most popular » selon le sexe (Kais 22/10)
      if (!show && b.getAttribute('aria-pressed') === 'true') { b.setAttribute('aria-pressed', 'false'); if (d.adv === b.dataset.key) d.adv = ''; }
    });
  }

  /* univers personnalisé */
  const BRANDS = /disney|pixar|pok[eé]mon|marvel|frozen|elsa|mickey|minnie|spider-?man|batman|superman|barbie|paw patrol|peppa|harry potter|hogwarts|star wars|mario|sonic|lego|dreamworks|bluey|minecraft|fortnite|avengers/i;
  const wt = $('syWorldTxt');
  const worldOk = () => wt.value.trim().length >= 15 && !BRANDS.test(wt.value);
  function worldState() {
    $('syWorldCount').textContent = wt.value.length;
    const on = wt.value.trim().length > 0;
    $('syWorld').classList.toggle('on', on);
    if (on) { $('syAdv').querySelectorAll('.adv').forEach((x) => x.setAttribute('aria-pressed', 'false')); d.adv = worldOk() ? 'custom' : ''; }
    else if (d.adv === 'custom') d.adv = '';
    $('syErr').textContent = BRANDS.test(wt.value) ? 'Please describe your world without brands or famous characters.' : '';
    if (step === 2) $('syNext').hidden = !d.adv;
  }
  wt.addEventListener('input', worldState);
  const IDEAS_ALL = String(CFG.worldIdeas || '').split(/\n+/).map((l) => l.split('|')).filter((x) => x[1]);
  const IDEA_GIRL = String(CFG.worldIdeaGirl || '').split('|');
  let IDEAS = IDEAS_ALL;
  function worldChips() {  // filles : la 1re suggestion (Medieval castle) devient Ice Queen (Kais 2026-10-11)
    IDEAS = d.g === 'girl' && IDEA_GIRL[1] ? [IDEA_GIRL, ...IDEAS_ALL.slice(1)] : IDEAS_ALL;
    $('syWorldChips').innerHTML = IDEAS.map((x, i) => `<button type="button" data-i="${i}" aria-pressed="false">${esc(x[0].trim())}</button>`).join('');
  }
  worldChips();
  $('syWorldChips').addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; wt.value = IDEAS[+b.dataset.i][1].trim(); worldState(); wt.focus(); });
  $('syInsp').addEventListener('click', () => { const x = IDEAS[Math.floor(Math.random() * IDEAS.length)]; if (x) { wt.value = x[1].trim(); worldState(); } });

  /* compagnons */
  document.querySelectorAll('.switch').forEach((sw) => sw.addEventListener('click', () => {
    const on = sw.getAttribute('aria-checked') !== 'true';
    sw.setAttribute('aria-checked', String(on));
    const card = $(sw.dataset.card); card.classList.toggle('on', on); card.querySelector('.card__body').hidden = !on;
    if (sw.dataset.card === 'syFriendCard') d.friend = on; else d.pet = on;
    if (on) { const i = card.querySelector('input'); if (i) setTimeout(() => i.focus(), 50); }
  }));
  const chips = (wrap, items, key, render) => {
    wrap.innerHTML = items.map((it) => render(it)).join('');
    wrap.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      const same = b.getAttribute('aria-pressed') === 'true';
      wrap.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', 'false'));
      if (!same) b.setAttribute('aria-pressed', 'true');
      d[key] = same ? '' : b.dataset.v;
    });
  };
  chips($('syHair'), list(CFG.hair), 'hair', (h) => `<button type="button" data-v="${esc(h)}" aria-pressed="false">${esc(h)}</button>`);
  chips($('syPetType'), list(CFG.pets), 'petType', (h) => `<button type="button" data-v="${esc(h)}" aria-pressed="false">${esc(h)}</button>`);
  chips($('syColor'), list(CFG.colors).map((c) => { const [n, hex] = c.split(':'); return {n: n.trim(), hex: (hex || '#ccc').trim()}; }), 'color',
    (c) => `<button type="button" data-v="${esc(c.n)}" aria-pressed="false"><span class="dot" style="background:${esc(c.hex)}"></span>${esc(c.n)}</button>`);

  /* message de fin */
  const msg = $('syMsg');
  msg.addEventListener('input', () => { $('syMsgCount').textContent = msg.value.length; });
  const lines = (t) => String(t || '').split(/\n+/).map((x) => x.trim()).filter(Boolean);
  const OCC = lines(CFG.occasions).map((l) => l.split('|'));
  d.passions = []; d.occasion = '';
  $('syPassions').innerHTML = lines(CFG.passions).map((p) => `<button type="button" aria-pressed="false" data-v="${esc(p.replace(/^[^\p{L}]+/u, ''))}">${esc(p)}</button>`).join('');
  $('syPassions').addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    const on = b.getAttribute('aria-pressed') !== 'true'; b.setAttribute('aria-pressed', String(on));
    d.passions = [...$('syPassions').querySelectorAll('[aria-pressed=true]')].map((x) => x.dataset.v);
  });
  $('syOccasion').innerHTML = OCC.map((o, i) => `<button type="button" aria-pressed="false" data-i="${i}">${esc(o[0])}</button>`).join('');
  $('syOccasion').addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    const same = b.getAttribute('aria-pressed') === 'true';
    $('syOccasion').querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', 'false'));
    if (!same) b.setAttribute('aria-pressed', 'true');
    const o = same ? null : OCC[+b.dataset.i];
    const prevAuto = msg.dataset.auto === '1';
    d.occasion = o ? o[0].replace(/^[^\p{L}]+/u, '') : '';
    if (o && o[1] && (!msg.value.trim() || prevAuto)) { msg.value = fill(o[1]).slice(0, 90); msg.dataset.auto = '1'; $('syMsgCount').textContent = msg.value.length; }
    ideas();
  });
  msg.addEventListener('input', () => { msg.dataset.auto = ''; });
  function ideas() {
    const sel = OCC.find((o) => o[0].replace(/^[^\p{L}]+/u, '') === d.occasion);
    const list = [...(sel ? [sel] : []), ...OCC.filter((o) => o !== sel)].map((o) => o[1]).filter(Boolean).slice(0, 3);
    $('syMsgIdeas').innerHTML = list.map((m) => `<button type="button" aria-pressed="false">${esc(fill(m))}</button>`).join('');
  }

  /* ---------- 3 histoires (API → Claude) ---------- */
  const curStory = () => (stState === 'done' && d.story !== null && stList[d.story]) ? stList[d.story] : null;
  let stKey = '', stState = '', stList = [];
  const stInput = () => {
    const a = adv() || {};
    return {name: name(), gender: d.g, age: $('syAge').value, stage: STAGES[stageOf(+$('syAge').value)].t, adventure: a.slug, adventureName: a.name,
      world: a.slug === 'custom' ? wt.value.trim() : '',
      friend: d.friend && $('syFriendName').value.trim() ? `${cap($('syFriendName').value)}${d.fg ? ' (' + d.fg + ')' : ''}` : '',
      pet: d.pet && $('syPetName').value.trim() ? `${d.petType || 'pet'} named ${cap($('syPetName').value)}` : '',
      passions: [...d.passions, $('syPassionOther').value.trim()].filter(Boolean), occasion: d.occasion};
  };
  async function loadStories(force) {
    const inp = stInput(), key = JSON.stringify(inp);
    if (!force && key === stKey && stState !== 'fail') { renderStories(); return; }
    stKey = key; stState = 'loading'; d.story = null; renderStories();
    const t0 = Date.now(), MIN = 12000; // durée mini pour laisser défiler les « Did you know? »
    try {
      const r = await fetch(CFG.api + '/stories', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(inp)});
      const j = await r.json();
      const left = MIN - (Date.now() - t0);
      if (left > 0) await new Promise((ok) => setTimeout(ok, left));
      if (stKey !== key) return;
      if (!r.ok || !j.stories || !j.stories.length) throw new Error('stories');
      stList = j.stories; stState = 'done'; evt('sy_stories_ready', {});
    } catch (e) { if (stKey === key) stState = 'fail'; }
    renderStories();
  }
  /* « Did you know? » qui défile pendant l'écriture des histoires */
  const DYK = lines(CFG.dyk).map((l) => l.split('|'));
  let dykTimer = null, dykI = 0;
  function dyk(on) {
    clearInterval(dykTimer);
    if (!on || !DYK.length || !$('syDykBody')) return;
    $('syDykDots').innerHTML = DYK.map(() => '<i></i>').join('');
    const show = () => {
      const body = $('syDykBody'); if (!body) { clearInterval(dykTimer); return; }
      const i = dykI++ % DYK.length, f = DYK[i];
      body.querySelectorAll('.dyk__item:not(.out)').forEach((o) => { o.classList.remove('in'); o.classList.add('out'); setTimeout(() => o.remove(), 650); });
      const el = document.createElement('div'); el.className = 'dyk__item';
      el.innerHTML = `<p>${esc(f[0])}</p>${f[1] ? `<small>\u2014 ${esc(f[1])}</small>` : ''}`;
      body.appendChild(el); setTimeout(() => el.classList.add('in'), 40);
      $('syDykDots').querySelectorAll('i').forEach((d, k) => d.classList.toggle('on', k === i));
    };
    show(); dykTimer = setInterval(show, 3000);
  }
  function renderStories() {
    const box = $('syStories');
    if (stState !== 'loading') dyk(false);
    $('syStoriesAgain').hidden = stState !== 'done';
    if (stState === 'loading') {
      box.innerHTML = `<p class="stories__wait">Writing ${esc(name())}\u2019s stories...</p><div class="dyk" id="syDyk"><span class="dyk__b">\u2605 Did you know?</span><div class="dyk__body" id="syDykBody"></div><div class="dyk__dots" id="syDykDots"></div><span class="dyk__bar"><i></i></span></div>` + [0, 1, 2].map(() => '<div class="story story--skel"><i></i><i></i><i></i></div>').join('');
      dyk(true);
    } else if (stState === 'fail') {
      box.innerHTML = `<div class="story story--fail"><b>Our storytellers will write the perfect story for ${esc(name())}.</b><p>You\u2019ll get it with the movie. Tap Next to continue.</p></div>`;
    } else if (stState === 'done') {
      box.innerHTML = stList.map((x, i) => `<button type="button" class="story" aria-pressed="${d.story === i}" data-i="${i}"><span class="story__n">${i + 1}</span><span class="story__t"><b>${esc(x.title)}</b><span>${esc(x.pitch)}</span></span><span class="pack__radio"></span></button>`).join('');
    }
    navLabel();
  }
  $('syStories').addEventListener('click', (e) => { const b = e.target.closest('.story[data-i]'); if (!b) return; d.story = +b.dataset.i; renderStories(); evt('sy_story_pick', {i: d.story}); });
  $('syStoriesAgain').addEventListener('click', () => loadStories(true));

  $('syMsgIdeas').addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    msg.value = b.textContent.slice(0, 90); $('syMsgCount').textContent = msg.value.length;
  });

  /* ---------- photo ---------- */
  const drop = $('syDrop');
  ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); drop.classList.add('drag'); }));
  ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); drop.classList.remove('drag'); }));
  drop.addEventListener('drop', (e) => { const f = e.dataTransfer.files[0]; if (f) takeFile(f); });
  $('syFile').addEventListener('change', () => { const f = $('syFile').files[0]; if (f) takeFile(f); });
  $('syChange').addEventListener('click', () => $('syFile').click());

  // Réduit la photo à 2000 px max en JPEG (upload plus rapide). Si le navigateur ne sait pas la lire (HEIC hors Safari), on garde l'original.
  async function shrink(f) {
    try {
      const url = URL.createObjectURL(f);
      const img = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = ko; i.src = url; });
      const k = Math.min(1, 2000 / Math.max(img.naturalWidth, img.naturalHeight));
      const c = document.createElement('canvas'); c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      const blob = await new Promise((ok) => c.toBlob(ok, 'image/jpeg', 0.9));
      URL.revokeObjectURL(url);
      if (!blob) return {file: f, thumb: ''};
      const base = (f.name || 'photo').replace(/\.[^.]+$/, '');
      return {file: new File([blob], base + '.jpg', {type: 'image/jpeg'}), thumb: URL.createObjectURL(blob)};
    } catch (e) { return {file: f, thumb: ''}; }
  }
  async function takeFile(f) {
    if (!/^image\//.test(f.type) && !/\.(heic|heif)$/i.test(f.name)) { $('syErr').textContent = 'Please choose a photo (JPG, PNG or HEIC).'; return; }
    if (f.size > 25 * 1024 * 1024) { $('syErr').textContent = 'This photo is too large. Please choose one under 25 MB.'; return; }
    $('syErr').textContent = '';
    const r = await shrink(f);
    d.file = r.file; d.thumb = r.thumb; d.fileStamp = Date.now();
    $('syThumb').src = r.thumb || '';
    $('syThumb').style.background = r.thumb ? '' : 'var(--brand-l)';
    $('syFileName').textContent = f.name;
    $('syPhotoOk').hidden = false; drop.hidden = true;
    evt('sy_photo_added', {});
    toDataURL(r.file).then((u) => { photoData = u; persist(); });
  }

  /* ---------- aperçu IA (API StarringYou → GPT Image 2) ---------- */
  const pv = {key: '', state: '', url: '', id: '', t0: 0, timer: null};
  const pvKey = () => [d.adv, d.adv === 'custom' ? wt.value.trim() : '', d.g, d.fileStamp, $('syDetails').value.trim()].join('|');  // l'histoire n'entre plus dans l'aperçu : il part dès la photo (gain ~2 min d'attente)
  const pvMesure = (ok) => {  // attente réelle du parent à l'écran de création → cockpit (moyenne, % sans attente, échecs)
    if (!pv.tMk || pv.mesure) return; pv.mesure = true;
    const secs = Math.max(0, Math.round((Date.now() - pv.tMk) / 1000));
    try { fetch(CFG.api + '/metric', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({type: 'preview_wait', id: pv.id || '', secs: ok ? secs : null, ok})}); } catch (e) {}
  };
  async function startPreview() {
    const a = adv(); if (!a || !d.file || !d.g || !consentOK()) return;
    const key = pvKey(); if (pv.key === key && pv.state !== 'fail') return;
    Object.assign(pv, {key, state: 'pending', reason: '', url: '', keep: '', id: '', video: '', t0: Date.now(), tMk: 0, mesure: false}); clearTimeout(pv.timer);
    { const inner = $('syPvFrame').querySelector('.pvx__inner'); inner.classList.remove('live'); inner.querySelectorAll('.pvx__vid,.pvx__live').forEach((x) => x.remove()); }
    try {
      const f = new FormData();
      f.append('photo', d.file, d.file.name); f.append('adventure', a.slug); f.append('gender', d.g); f.append('name', name()); f.append('age', $('syAge').value);
      if (a.slug === 'custom') f.append('world', wt.value.trim().slice(0, 500));
      if ($('syDetails').value.trim()) f.append('details', $('syDetails').value.trim().slice(0, 200));
      const r = await fetch(CFG.api + '/preview', {method: 'POST', body: f});
      const j = await r.json();
      if (pv.key !== key) return;
      if (!r.ok || !j.id) { pv.reason = r.status === 429 ? 'rate' : r.status === 400 || r.status === 413 ? 'photo' : 'busy'; throw new Error(j.error || 'preview'); }
      pv.id = j.id; evt('sy_preview_started', {adventure: a.slug});
      poll(key);
    } catch (e) { if (pv.key === key) { pv.reason = pv.reason || 'busy'; pv.state = 'fail'; renderPv(); } }
  }
  async function poll(key) {
    if (pv.key !== key) return;
    try {
      const j = await (await fetch(CFG.api + '/preview/' + pv.id)).json();
      if (pv.key !== key) return;
      if (j.state === 'done' && j.url) {
        if (pv.state !== 'done') { pv.state = 'done'; pv.url = j.url; pvMesure(true); const im = new Image(); im.onload = () => { renderPv(true); }; im.src = j.url; evt('sy_preview_ready', {secs: Math.round((Date.now() - pv.t0) / 1000)}); klSync(plData ? {pv: pv.id, snap: Object.assign(snapshot(), {photo: '', pv: null}), line: plData.trailer_line, story: (curStory() || {}).title} : {pv: pv.id}); }
        if (j.anim === 'done' && j.video) { showVideo(CFG.api + j.video); return; }
        if (j.anim !== 'pending' || Date.now() - pv.t0 > 420000) return;
        pv.timer = setTimeout(() => poll(key), 3000); return;
      }
      if (j.state === 'fail') { pv.reason = 'photo'; pv.state = 'fail'; pvMesure(false); renderPv(); return; }
    } catch (e) {}
    if (Date.now() - pv.t0 > 260000) { pv.state = 'fail'; renderPv(); return; }
    pv.timer = setTimeout(() => poll(key), 3000);
  }
  const MSGS = ['Scanning {name}\u2019s smile...', 'Sketching {name}\u2019s face...', 'Choosing the costume...', 'Building the {adventure} world...', 'Adding movie magic...', 'Almost there...'];
  let msgTimer = null;
  /* phrases qui défilent pendant la création (une toutes les 4 s) */
  let tipTimer = null, tipIdx = 0;
  function tips(on) {
    const box = $('syTips');
    clearInterval(tipTimer);
    if (!on) { box.hidden = true; box.innerHTML = ''; return; }
    const list = String(CFG.pvTips || '').split(/\n+/).map((x) => x.trim()).filter(Boolean);
    if (!list.length) return;
    box.hidden = false;
    const show = () => {
      box.querySelectorAll('.pvx__tip:not(.out)').forEach((o) => { o.classList.remove('in'); o.classList.add('out'); setTimeout(() => o.remove(), 700); });
      const el = document.createElement('p'); el.className = 'pvx__tip'; el.textContent = fill(list[tipIdx++ % list.length]);
      box.appendChild(el);
      setTimeout(() => el.classList.add('in'), 40);
    };
    if (!box.querySelector('.pvx__tip')) show();
    tipTimer = setInterval(show, 4000);
  }
  function renderPv(reveal) {
    if (step !== PV) { tips(false); clearInterval(msgTimer); navLabel(); return; }
    const fr = $('syPvFrame');
    fr.dataset.state = pv.state || 'pending';
    $('syPvPhoto').src = CFG.pvWaitImg || d.thumb || ''; fr.classList.toggle('pvx__frame--wait', !!CFG.pvWaitImg);  // en attente : toujours la même image de dessin, floutée
    clearInterval(msgTimer);
    if (pv.state === 'done') {
      tips(false);
      $('syPvImg').src = pv.url;
      $('syPvTitle').textContent = fill(CFG.pvTitle).replace('{hero}', heroTitle().split(' and ')[0]);
      $('syPvSub').textContent = fill(CFG.pvSub);
      $('syPvRetry').hidden = false;
      if (reveal) confetti();
    } else if (pv.state === 'fail') {
      tips(false);
      const R = {
        photo: ['Let\u2019s try another photo', 'This photo didn\u2019t work', 'Try a clear, well-lit photo where your child faces the camera.', 'Our magic works best with a clear photo where ' + name() + ' faces the camera, in good light.'],
        busy: ['Our studio is very busy', 'Just a little hiccup', 'Tap the button to try again with the same photo.', 'Lots of families are creating previews right now. Try again in a moment.'],
        rate: ['You\u2019ve made a lot of previews!', 'Preview limit reached', 'You can create more previews in about an hour.', 'You can still continue and create ' + name() + '\u2019s movie now.'],
      }[pv.reason || 'photo'];
      $('syPvTitle').textContent = R[0]; $('syFailT').textContent = R[1]; $('syFailS').textContent = R[2]; $('syPvSub').textContent = R[3];
      $('syPvAgain').hidden = pv.reason !== 'busy';
      $('syPvRetry').hidden = false;
      evt('sy_preview_failed', {});
    } else {
      $('syPvTitle').textContent = fill(CFG.pvWait);
      $('syPvSub').textContent = '';
      $('syPvRetry').hidden = true;
      tips(true);
      const tick = () => {
        const el = (Date.now() - pv.t0) / 1000;
        $('syPvBar').style.width = Math.min(95, 100 * (1 - Math.exp(-el / 45))) + '%';
        $('syPvMsg').textContent = fill(MSGS[Math.min(MSGS.length - 1, Math.floor(el / 14))]);
      };
      tick(); msgTimer = setInterval(tick, 500);
    }
    navLabel();
  }
  function showVideo(src) {
    if (pv.video === src) return;
    pv.video = src;
    const inner = $('syPvFrame').querySelector('.pvx__inner');
    const v = document.createElement('video');
    Object.assign(v, {muted: true, defaultMuted: true, loop: true, autoplay: true, playsInline: true});
    v.setAttribute('playsinline', ''); v.className = 'pvx__vid'; v.src = src;
    v.addEventListener('canplay', () => { v.play().catch(() => {}); inner.classList.add('live'); evt('sy_preview_live', {}); }, {once: true});
    inner.appendChild(v);
    if (!inner.querySelector('.pvx__live')) { const b = document.createElement('span'); b.className = 'pvx__live'; b.textContent = 'LIVE'; inner.appendChild(b); }
  }
  /* ---------- intrigue + « what happens » (API → Claude), écrits pendant l'écran de création ---------- */
  let plKey = '', plData = null;
  const THEME_STORIES = {"christmas": {"plot": "Christmas needs a little hero, and {name} is ready to help. As Santa’s little helper, {name} sets off on a Christmas rescue. The mission is clear: save Christmas before midnight. Every moment brings the big night closer. Will {name} complete the mission in time? Find out what happens next in {name}’s movie!", "line": "{name}, only you can save Christmas!", "cast": [["{name}", "Santa’s little helper"], ["Santa", "needs a hand before midnight"], ["The elves", "racing to get every gift ready"]], "beats": ["{name} is called to the North Pole", "Santa’s sleigh won’t take off", "The gifts start to disappear…", "{name} spots a clue nobody noticed"], "lesson": "That kindness and courage can save the most magical night of the year."}, "safari": {"plot": "A lost lion cub needs to find the way home. Luckily, {name} is ready for a safari adventure. In the savanna, {name} has an important mission: bring the little cub home before sunset. This is a journey that calls for courage and kindness. Will {name} and the cub make it back in time? Find out what happens next in {name}’s movie!", "line": "{name}, only you can bring the cub home!", "cast": [["{name}", "the safari explorer"], ["Kito", "the little lion cub who got lost"], ["Tembo", "the wise old elephant who knows the way"]], "beats": ["{name} hears a tiny roar in the tall grass", "Kito is lost, far from the pride", "Tembo leads them across the river", "The sun starts to go down…"], "lesson": "That real heroes take care of the little ones."}, "dinosaur": {"plot": "In a lost valley of dinosaurs, {name} meets a baby dinosaur that needs help. The little dinosaur is far from home. Now {name} has an important mission: help the baby find the way back. A dinosaur adventure is about to begin, with {name} as the hero. Will the little explorer bring this new friend home? Find out what happens next in {name}’s movie!", "line": "{name}, only you can bring the baby dino home!", "cast": [["{name}", "the little explorer"], ["Pebbles", "the baby triceratops who lost her mom"], ["Big Rex", "the giant T-rex who guards the valley"]], "beats": ["{name} finds a giant egg about to hatch", "Pebbles needs to find the way home", "Big Rex blocks the path…", "{name} has an idea nobody saw coming"], "lesson": "That you can be small and still be very brave."}, "superhero": {"plot": "The city needs a hero, and {name} is about to become one. It all begins when {name} discovers a secret superpower. A brand-new superhero adventure is waiting. Now {name} must find the courage to help save the city. What will happen when this new hero puts that power to the test? Find out what happens next in {name}’s movie!", "line": "{name}, the city needs you!", "cast": [["{name}", "the brand-new superhero"], ["Granny Gadget", "the inventor who helps {name}"], ["Grumpy", "the grumpy villain with a big plan"]], "beats": ["{name} discovers a secret superpower", "Granny Gadget builds a super suit", "Grumpy’s robots take over the city…", "{name} has to choose: hide or fly"], "lesson": "That being brave means helping, even when you’re scared."}, "knight": {"plot": "A dragon has a secret, and {name} is ready to uncover it. As a brave knight, {name} rides out on a special quest. This adventure brings {name} into a world of knights and dragons. At the heart of the journey is a mystery waiting to be understood. What will {name} discover about the dragon? Find out what happens next in {name}’s movie!", "line": "{name}, only you can uncover the dragon’s secret!", "cast": [["{name}", "the brave little knight"], ["Ember", "the baby golden dragon"], ["Baron Rustybuckle", "the rusty baron with a big mustache"]], "beats": ["{name} rides out on a special quest", "A golden dragon lands in the meadow", "Baron Rustybuckle has other plans…", "The dragon’s secret is about to come out"], "lesson": "That a true knight listens before fighting."}, "pirate": {"plot": "An old treasure map is the start of {name}’s pirate adventure. With a map, a ship and a lost treasure to find, Captain {name} is ready to go. This time, {name} is the hero leading the quest. The search for the treasure is about to begin. Where will the old map lead Captain {name}? Find out what happens next in {name}’s movie!", "line": "Captain {name}, the treasure is waiting!", "cast": [["Captain {name}", "the pirate leading the quest"], ["Polly", "the talking parrot who reads maps"], ["Captain Grumblebeard", "the pirate who wants the treasure too"]], "beats": ["An old map washes up on the beach", "Captain {name} sets sail with the crew", "Captain Grumblebeard is right behind them…", "The X on the map isn’t where it should be"], "lesson": "That a great captain always takes care of the crew."}, "princess": {"plot": "An enchanted castle is waiting for {name}. The kingdom needs a hero to break the spell over the castle. Now {name} has an important part to play in this royal adventure. With {name} at the heart of the story, the quest to help the kingdom begins. Will {name} be able to break the spell? Find out what happens next in {name}’s movie!", "line": "{name}, only you can break the spell!", "cast": [["Princess {name}", "the hero of the kingdom"], ["Sparkle", "the baby unicorn with a rainbow mane"], ["Duchess Grumbelda", "the grumpy duchess who cast the spell"]], "beats": ["{name} arrives at the enchanted castle", "Sparkle the unicorn asks for help", "Duchess Grumbelda’s spell grows stronger…", "{name} finds the key nobody could find"], "lesson": "That a kind heart is the strongest magic of all."}, "fairy": {"plot": "The fairy kingdom needs {name}’s help. Its last glowing flower must be saved. In a world of fairy dust, magic and wonder, {name} becomes the hero of the adventure. The mission leads straight to the heart of this magical kingdom. Will {name} be able to save its last glowing flower? Find out what happens next in {name}’s movie!", "line": "{name}, only you can save the last glowing flower!", "cast": [["{name}", "the fairy hero"], ["Twinkle", "the tiny fairy who glows in the dark"], ["Grumbletoad", "the grumpy toad who took the flower’s light"]], "beats": ["{name} flies into the fairy kingdom", "Twinkle shows the last glowing flower", "Its light is fading fast…", "{name} discovers a magic nobody knew about"], "lesson": "That a little light can change everything."}};
  function loadPlot() {
    const a = adv();
    if (!a) { plData = null; renderPlot(); return; }
    const slug = ({superheroine: 'superhero', spider: 'superhero'})[a.slug] || a.slug;
    const ts = THEME_STORIES[slug];
    plData = ts ? {plot: fill(ts.plot), line: fill(ts.line), beats: ts.beats.map(fill), cast: ts.cast.map((c) => ({name: fill(c[0]), role: fill(c[1])})), lesson: fill(ts.lesson)}
      : {plot: fill(a.quest || ''), beats: [], cast: []};
    renderPlot();
  }
  // Klaviyo (relances panier / tunnel) : prénom, aperçu gardé pour de bon, histoire. Le serveur renvoie le lien permanent de l'aperçu.
  function klSync(extra) {
    if (!CFG.api || !validEmail()) return;
    fetch(CFG.api + '/kl', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(Object.assign({email: $('syEmail').value.trim(), hero: name()}, extra))})
      .then((r) => r.json()).then((j) => { if (j && j.preview && extra.pv === pv.id) pv.keep = j.preview; }).catch(() => {});
  }
  function put0(card, id, txt) { $(card).hidden = !txt; if (txt) $(id).textContent = txt; }
  function renderPlot() {
    const box = $('syPlot'); box.hidden = !plData;
    if (!plData) return;
    $('syPlotTxt').textContent = plData.plot;
    $('syPlotIntro').textContent = `${name()}\u2019s adventure, without giving it all away. We\u2019re keeping the ending for movie night.`;
    put0('syPlotLineC', 'syPlotLine', plData.line);
    $('syPlotLock').hidden = !plData.beats.length;
    $('syPlotParent').textContent = d.g === 'girl' ? 'Imagine her face when she sees herself as the hero on TV.' : d.g === 'boy' ? 'Imagine his face when he sees himself as the hero on TV.' : 'Imagine their face when they see themselves as the hero on TV.';
    $('syPlotBeats').innerHTML = plData.beats.map((b) => `<li>${esc(b)}</li>`).join('');
    // détails à lire pendant que l'aperçu se génère (propres à chaque histoire)
    const put = (card, id, txt) => { $(card).hidden = !txt; if (txt) $(id).textContent = txt; };
    put('syPlotPlaceC', 'syPlotPlace', plData.place); $('syPlotPlaceD').textContent = plData.place_desc || '';
    put('syPlotMissionC', 'syPlotMission', plData.mission);
    put('syPlotLessonC', 'syPlotLesson', plData.lesson);
    const cast = plData.cast || []; $('syPlotCastC').hidden = !cast.length;
    $('syPlotCast').innerHTML = cast.map((c) => `<li><b>${esc(c.name)}</b><span>${esc(c.role)}</span></li>`).join('');
  }

  /* ---------- écran de création : vidéos à la suite + phases qui se remplissent (habille la vraie attente) ---------- */
  let mkDeadline = null, mkTimer = null, mkVidTimer = null, mkPh = 0, mkPct = 0, mkOn = false;
  const mkMs = () => 10000;  // durée minimale de l'écran ; la 7e étape attend ensuite l'aperçu (voir maker)
  function mkVideos(on) {
    clearInterval(mkVidTimer);
    const vs = [...document.querySelectorAll('#syMkVid video')];
    vs.forEach((v) => { v.muted = true; v.playsInline = true; v.pause(); });
    if (!on) document.querySelectorAll('#syMkVid .mk__fb').forEach((e) => e.remove());
    if (!on || !vs.length) return;
    let i = 0;
    // lecture auto bloquée (iPhone en économie d'énergie) → la même animation en WebP animé, sans bouton
    const box = $('syMkVid'), secours = () => {
      if (!CFG.api || box.querySelector('.mk__fb')) return;
      const im = new Image(); im.className = 'mk__fb'; im.alt = ''; im.src = CFG.api + '/anim/sy-loader-all.webp';
      im.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:2';
      box.appendChild(im); vs.forEach((x) => { x.onended = null; });
    };
    let play = () => { vs.forEach((v, k) => v.classList.toggle('on', k === i)); const v = vs[i]; v.currentTime = 0; const p = v.play(); if (p && p.catch) p.catch(secours);
      setTimeout(() => { if (mkOn && v.paused && v.classList.contains('on')) secours(); }, 1500); };
    vs.forEach((v) => { v.loop = true; v.onended = null; });  // c'est le minuteur qui passe à la vidéo suivante
    const play0 = play; play = () => { vs.forEach((x, k) => { if (k !== i) x.pause(); }); play0(); };
    play();
    const slot = mkMs() / vs.length;  // 4-5 vidéos différentes dans les ~15 s de l'écran
    mkVidTimer = setInterval(() => { if (!mkOn || box.querySelector('.mk__fb')) return; i = (i + 1) % vs.length; play(); }, slot);
  }
  function mkPhases() {
    const a = adv() || {}, st = curStory();
    const crew = [d.friend && $('syFriendName').value.trim() ? cap($('syFriendName').value) : '', d.pet && $('syPetName').value.trim() ? cap($('syPetName').value) : ''].filter(Boolean).join(' and ');
    return lines(CFG.mkPhases).filter((l) => crew || !/\{crew\}/.test(l))
      .map((l) => fill(l).replace('{crew}', crew).replace('{story}', st ? '\u201c' + st.title + '\u201d' : 'the story'));
  }
  function maker(on) {
    clearTimeout(mkDeadline); clearInterval(mkTimer); mkOn = on; mkVideos(on);
    if (!on) return;
    mkDeadline = setTimeout(() => { if (step === MK) go(PV); }, 10000);
    const P = mkPhases(); mkPh = 0; mkPct = 0; $('syMkDone').innerHTML = '';
    const setP = () => { $('syMkPhase').textContent = P[mkPh] + '...'; $('syMkCount').textContent = `${mkPh + 1}/${P.length}`; $('syMkBar').style.width = mkPct + '%'; };
    setP();
    const t0 = Date.now(), per = (mkMs() - 450) / P.length;  // calé sur l'horloge (les minuteurs ralentissent en arrière-plan)
    const WAIT = 60000;  // Kais 2026-10-06 : un seul chargement — la dernière étape (7/7) attend que l'aperçu soit prêt (60 s max)
    mkTimer = setInterval(() => {
      const el = Date.now() - t0;
      const attend = false;
      let ph = Math.min(P.length, Math.floor(el / per));
      if (attend) ph = Math.min(ph, P.length - 1);
      while (mkPh < ph) {
        const li = document.createElement('li'); li.innerHTML = ICON('check') + esc(P[mkPh]); $('syMkDone').prepend(li);
        if (mkPh === P.length - 1) { mkPh = P.length; mkPct = 100; $('syMkBar').style.width = '100%'; clearInterval(mkTimer); return; }
        mkPh++;
      }
      mkPct = Math.min(100, 100 * (el - mkPh * per) / per);
      if (attend && mkPh === P.length - 1) mkPct = 95 * (1 - Math.exp(-(el - mkPh * per) / 14000));  // 7/7 : la barre ralentit sans jamais finir tant que l'aperçu n'est pas prêt
      setP();
    }, 120);
  }
  function confetti() {
    const c = $('syConfetti'); c.innerHTML = '';
    const cols = ['#FFC83D', '#FF6B5B', '#6B45F5', '#22B573', '#fff', '#FF8FC8'];
    for (let i = 0; i < 46; i++) {
      const e = document.createElement('i');
      const ang = Math.random() * Math.PI * 2, dist = 120 + Math.random() * 190;
      e.style.cssText = `--x:${Math.cos(ang) * dist}px;--y:${Math.sin(ang) * dist - 60}px;--r:${Math.random() * 720 - 360}deg;background:${cols[i % cols.length]};animation-delay:${Math.random() * 0.15}s`;
      c.appendChild(e);
    }
    setTimeout(() => { c.innerHTML = ''; }, 2200);
  }
  $('syPvAgain').addEventListener('click', () => { pv.key = ''; startPreview(); renderPv(); });
  $('syPvRetry').addEventListener('click', () => { d.file = null; d.thumb = ''; $('syPhotoOk').hidden = true; $('syDrop').hidden = false; $('syFile').value = ''; go(3); });

  /* ---------- packs + options ---------- */
  const packTitle = (i) => { const pk = CFG.packs[i] || {}; return fill(pk.title || '') || CFG.variants[i].title; };
  const packTitleHtml = (i) => { const t = packTitle(i), k = t.indexOf('+'); return k > 0 ? `<b>${esc(t.slice(0, k).trim())}</b><span class="pack__free">${esc(t.slice(k).replace(/^\+\s*/, '+'))}</span>` : `<b>${esc(t)}</b>`; };
  const packGifts = (i) => String((CFG.packs[i] || {}).gifts || '').split('\n').map((l) => l.trim()).filter(Boolean)
    .map((l) => { const k = l.indexOf('|'); return k > 0 ? {icon: l.slice(0, k).trim(), text: fill(l.slice(k + 1).trim())} : {icon: '', text: fill(l)}; });
  function packs() {
    const v = CFG.variants;
    $('syPacks').innerHTML = v.map((x, i) => {
      const n = parseInt(x.title, 10) || 1, pk = CFG.packs[i] || {sub: ''};
      const per = n > 1 ? `${money(Math.round(x.price / n))} / episode` : '';
      const gl = packGifts(i);
      const gift = gl.length ? `<span class="pack__gift"><em>${esc(CFG.giftsLabel || 'FREE GIFTS')}</em>${gl.map((g) => `<span class="pack__gl">${CFG.giftImgs[g.icon] ? `<img src="${esc(CFG.giftImgs[g.icon])}" alt="" width="44" height="44">` : ''}<b>${esc(g.text)}</b></span>`).join('')}</span>` : '';
      return `<button type="button" class="pack${gl.length ? ' pack--gift' : ''}" data-i="${i}" aria-pressed="${i === d.pack}">${pk.badge ? `<span class="pack__badge${i === 2 ? ' pack__badge--alt' : ''}">${esc(pk.badge)}</span>` : ''}<span class="pack__main"><span class="pack__radio"></span><span class="pack__t">${packTitleHtml(i)}<small>${esc(fill(pk.sub))}</small></span><span class="pack__p">${x.compare > x.price ? `<s>${money(x.compare)}</s>` : ''}<b>${money(x.price)}</b>${per ? `<small>${per}</small>` : ''}</span></span>${gift}</button>`;
    }).join('');
    { let pc = $('syPromoCode'); if (!pc) { pc = document.createElement('p'); pc.id = 'syPromoCode'; pc.className = 'packs__promo'; $('syPacks').after(pc); }
      pc.hidden = !d.code; if (d.code) pc.innerHTML = `${ICON('check')} Code <b>${esc(d.code)}</b> applied at checkout: ${(d.code.match(/(\d{1,2})$/) || [0, 15])[1]}% off`; }  // HERO15 → 15 %, HERO20 → 20 % (Kais 2026-10-06)
    $('syAddons').innerHTML = CFG.addons.map((a) => `<button type="button" class="addon${d.addons[a.key] ? ' on' : ''}" data-k="${a.key}"${a.key === 'christmas' ? ' style="padding:10px 14px;border:1.5px solid #6B45F5;border-style:solid;background:#F4F0FF;border-radius:12px;min-height:0"' : ''}><span class="addon__box">${ICON('check')}</span><span class="addon__t"${a.key === 'christmas' ? ' style="font-size:15px"' : ''}><b>${esc(fill(a.title))}</b>${a.sub ? `<small>${esc(fill(a.sub))}</small>` : ''}</span><span class="addon__p">+${money(a.price)}</span></button>`).join('');
    sum();
  }
  $('syPacks').addEventListener('click', (e) => { const b = e.target.closest('.pack'); if (!b) return; d.pack = +b.dataset.i; packs(); evt('sy_pack_select', {pack: CFG.variants[d.pack].title}); });
  $('syAddons').addEventListener('click', (e) => { const b = e.target.closest('.addon'); if (!b) return; d.addons[b.dataset.k] = !d.addons[b.dataset.k]; packs(); });
  const shipFee = () => (CFG.ship && !(CFG.packs[d.pack] || {}).gift) ? CFG.ship.price : 0;
  const total = () => CFG.variants[d.pack].price + shipFee() + CFG.addons.reduce((t, a) => t + (d.addons[a.key] ? a.price : 0), 0);
  function sum() {
    const v = CFG.variants[d.pack], a = adv();
    const st = stState === 'done' && d.story !== null ? stList[d.story] : null;
    let h = `<div class="sum__row"><span>Movie</span><b>${esc(st ? st.title : heroTitle())}</b></div>`;
    h += `<div class="sum__row"><span>Adventure</span><b>${esc(a ? a.name : '')}</b></div>`;
    h += `<div class="sum__row"><span>${esc(packTitle(d.pack))}</span><b>${money(v.price)}</b></div>`;
    packGifts(d.pack).forEach((g) => { h += `<div class="sum__row"><span>${esc(g.text)}</span><b>FREE</b></div>`; });
    CFG.addons.forEach((x) => { if (d.addons[x.key]) h += `<div class="sum__row"><span>${esc(fill(x.title))}</span><b>${money(x.price)}</b></div>`; });
    h += `<div class="sum__row"><span>Delivery by email (${esc(CFG.delivery.replace(/^By email, within /i, ''))})</span><b${shipFee() ? '' : ' class="free"'}>${shipFee() ? money(shipFee()) : 'FREE'}</b></div>`;
    h += `<div class="sum__row sum__tot"><span>Total</span><b>${money(total())}</b></div>`;
    h += `<div class="sum__guar">🛡️ 90-Day Money-Back Guarantee</div>`;
    $('sySum').innerHTML = h;
    if (step === LAST) navLabel();
  }

  /* ---------- email (lead) ---------- */
  function sendLead() {
    if (leadSent || !validEmail()) return;
    leadSent = true;
    evt('sy_lead', {step: 1});
    fetch(CFG.api + '/lead', {method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({email: $('syEmail').value.trim(), name: name(), gender: d.g, age: $('syAge').value, adventure: (adv() || {}).slug || ''})}).catch(() => {});
  }

  /* ---------- navigation ---------- */
  function check() {
    if (step === 1) {
      if ($('syName').value.trim().length < 2) { $('syName').focus(); return 'Please enter the hero’s first name.'; }
      if (!d.g) return 'Is the hero a boy or a girl?';
      if (!ageSet) { $('syAge').focus(); return 'Please set the hero’s age with the slider.'; }
      if (!validEmail()) { $('syEmail').focus(); return 'Please enter a valid email to receive the preview.'; }
    }
    if (step === 2 && !d.adv) return 'Pick an adventure.';   // Kais 22/10 : plus de monde perso
    if (step === 4) {
      if (d.friend && $('syFriendName').value.trim().length < 2) { $('syFriendName').focus(); return 'What’s the best friend’s name?'; }
      if (d.pet && !d.petType) return 'What kind of pet is it?';
      if (d.pet && $('syPetName').value.trim().length < 1) { $('syPetName').focus(); return 'What’s the pet’s name?'; }
    }
    if (step === 3 && !consentOK()) return consentError();
    if (step === 3 && !d.file) return 'Please add a photo so we can create ' + name() + '’s hero.';
    return '';
  }
  function navLabel() {
    if (step === 7 && stState === 'loading') { $('syNext').disabled = true; $('syNext').textContent = 'Writing the stories...'; return; }
    if (step === PV) {
      const wait = pv.state === 'pending';
      $('syNext').disabled = wait;
      $('syNext').innerHTML = wait ? `Creating ${esc(name())}\u2019s hero...` : pv.state === 'fail' ? `Continue anyway${ICON('arrow-right')}` : `Make ${esc(name())}\u2019s movie${ICON('arrow-right')}`;
      return;
    }
    $('syNext').disabled = false;
    $('syNext').innerHTML = step === LAST ? `${ICON('lock')}${esc(fill(CFG.payLabel))} · ${money(total())}` : step === PV ? `Choose ${esc(name())}’s pack${ICON('arrow-right')}` : `Next${ICON('arrow-right')}`;
  }
  function go(n, push = true) {
    if (n === MK && step === PV) n = MK - 1;
    while ([4, 5, 7].includes(n)) n += n < step ? -1 : 1;  // écran compagnons (ami / animal) retiré le 17/10 (Kais) : trop de ratés en fabrication
    step = Math.max(1, Math.min(LAST, n));
    if (push) { const u = new URL(location.href); u.searchParams.set('step', step); history.pushState({s: step}, '', u); }
    document.querySelectorAll('.scr').forEach((s) => { s.hidden = +s.dataset.s !== step; });
    const pct = Math.round(((STEPS.indexOf(step) + 1) / STEPS.length) * 100);
    $('syProg').style.width = pct + '%';
    $('syCount').textContent = `Step ${STEPS.indexOf(step) + 1} of ${STEPS.length}`;
    $('syBack').hidden = step === 1;
    $('syErr').textContent = '';
    texts();
    if (step === 6) ideas();
    // Story selection removed: the chosen theme determines the fixed adventure.
    document.body.classList.toggle('pv-on', step === PV);
    if (step > 3 && step < MK && d.file) startPreview();  // l'aperçu (1 à 2 min chez Kie) se fabrique pendant les écrans 5 à 7
    if (step === MK) { startPreview(); if (!pv.tMk) pv.tMk = Date.now(); if (pv.state === 'done') pvMesure(true); loadPlot(); maker(true); } else maker(false);
    if (step === PV) loadPlot();
    if (step === PV) { startPreview(); renderPv(); }
    if (step === LAST) { const h = $('syPackHero'); h.hidden = !(pv.state === 'done' && pv.url); if (pv.url) h.src = pv.url; }
    if (step === LAST) packs();
    navLabel();
    $('syNext').hidden = (step === 2 && !d.adv) || step === MK;
    $('syMicro').hidden = step === MK || step === LAST;
    $('syPayBadges').hidden = step !== LAST;
    if ($('syGuar')) $('syGuar').hidden = step !== LAST;  // garantie sous le bouton de paiement
    track(step, NAMES[step], {adventure: (adv() || {}).slug || '', gender: d.g});
    window.scrollTo({top: 0});
    save();
  }
  $('syNext').addEventListener('click', () => {
    if (step === LAST) return pay();
    const m = check(); if (m) { $('syErr').textContent = m === 'Please check this box to continue.' ? '' : m; return; }
    if (step === 1) sendLead();
    go(step + 1);
  });
  $('syBack').addEventListener('click', () => history.length > 1 && history.state && history.state.s ? history.back() : go(step - 1));
  window.addEventListener('popstate', (e) => {
    const s = (e.state && e.state.s) || 1;
    // on ne peut pas revenir sur un écran dont les étapes précédentes ne sont pas remplies
    let ok = 1; for (let i = 1; i < s; i++) { step = i; if (check()) break; ok = i + 1; }
    go(Math.min(s, ok), false);
  });
  $('syName').addEventListener('keydown', (e) => { if (e.key === 'Enter') $('syEmail').focus(); });

  // Consent is explicit, saved with the photo, and required before any preview upload.
  let consentAt = '';
  const consentOK = () => $('syPhotoPermission').checked;
  function consentError() {
    const box = $('syPhotoConsent'); box.classList.add('has-error');
    $('syPhotoPermission').setAttribute('aria-invalid', 'true');
    $('syPhotoConsentError').hidden = false;
    box.scrollIntoView({behavior: 'smooth', block: 'center'});
    $('syPhotoPermission').focus({preventScroll: true});
    return 'Please check this box to continue.';
  }
  $('syPhotoPermission').addEventListener('change', () => {
    consentAt = consentOK() ? new Date().toISOString() : '';
    $('syPhotoConsent').classList.remove('has-error');
    $('syPhotoPermission').removeAttribute('aria-invalid');
    $('syPhotoConsentError').hidden = true; $('syErr').textContent = ''; save();
  });

  /* ---------- paiement ---------- */
  async function pay() {
    if (!consentOK()) { go(3); consentError(); return; }
    const btn = $('syNext'); btn.disabled = true; const old = btn.innerHTML; btn.textContent = 'Opening secure checkout...';
    evt('sy_checkout', {value: total() / 100, currency: CFG.currency, pack: CFG.variants[d.pack].title});
    try {
      const a = adv();
      await fetch('/cart/clear.js', {method: 'POST', headers: {Accept: 'application/json'}});
      const f = new FormData();
      f.append('id', CFG.variants[d.pack].id); f.append('quantity', '1');
      const P = (k, v) => { if (v) f.append(`properties[${k}]`, v); };
      P('Photo permission', 'Confirmed'); P('_photo_permission_at', consentAt);
      P('Pack', packTitle(d.pack)); { const gl = packGifts(d.pack); if (gl.length) P('Free gifts', gl.map((g) => g.text).join(' + ')); } if (d.addons.christmas) P('Christmas Song', 'Yes');  // option chanson d'Halloween (Aymen 2026-10-09, remise par Kais 2026-10-11)
      P('Hero', name()); P('Boy / Girl', d.g === 'girl' ? 'Girl' : 'Boy'); P('Age', $('syAge').value === '0' ? 'Newborn' : $('syAge').value); P('Story level', STAGES[stageOf(+$('syAge').value)].t);
      P('Adventure', a ? a.name : ''); P('Movie title', heroTitle());
      if (a && a.slug === 'custom') P('Custom world', wt.value.trim());
      if (stState === 'done' && d.story !== null && stList[d.story]) { P('Story', stList[d.story].title); P('_story_pitch', stList[d.story].pitch); P('_story_arc', stList[d.story].arc); }
      { const ps = [...d.passions, $('syPassionOther').value.trim()].filter(Boolean); if (ps.length) P('Passions', ps.join(', ')); }
      if (plData) { P('_plot', plData.plot); P('_beats', plData.beats.join(' | ')); }
      P('Occasion', d.occasion);
      if (d.friend) P('Best friend', [cap($('syFriendName').value), d.fg, d.hair ? d.hair + ' hair' : ''].filter(Boolean).join(', '));
      if (d.pet) P('Pet', [d.petType, cap($('syPetName').value)].filter(Boolean).join(': '));
      P('Favorite color', d.color); P('Other details', $('syDetails').value.trim()); P('End message', msg.value.trim());
      if (d.file) f.append('properties[Photo]', d.file, d.file.name);
      if (pv.state === 'done') P('_preview', pv.keep || pv.url);  // lien permanent (fichiers Shopify) dès qu'il existe
      P('_email', $('syEmail').value.trim()); P('_adventure', a ? a.slug : '');
      const r = await fetch('/cart/add.js', {method: 'POST', body: f, headers: {Accept: 'application/json'}});
      if (!r.ok) throw new Error('add');
      const extra = CFG.addons.filter((x) => d.addons[x.key]).map((x) => ({id: x.id, quantity: 1, properties: {Hero: name(), _gender: d.g, _lang: 'en', ...(x.key === 'christmas' ? {_song_theme: 'NOEL'} : {})}}));
      if (shipFee()) extra.push({id: CFG.ship.id, quantity: 1});
      if (extra.length) await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: extra})});
      location.href = d.code ? '/checkout?discount=' + encodeURIComponent(d.code) : '/checkout';  // code promo des emails de relance, appliqué au paiement
    } catch (e) {
      btn.disabled = false; btn.innerHTML = old;
      $('syErr').textContent = 'Checkout couldn’t open. Please try again in a moment.';
    }
  }

  /* ---------- mémoire de session (sans la photo) ---------- */
  function save() {
    persist();
    try { sessionStorage.setItem('sy_state', JSON.stringify({name: $('syName').value, g: d.g, age: $('syAge').value, email: $('syEmail').value, adv: d.adv, color: d.color, msg: msg.value, pack: d.pack, world: wt.value})); } catch (e) {}
  }
  function restore() {
    let s = {};
    try { s = JSON.parse(sessionStorage.getItem('sy_state') || '{}'); } catch (e) {}
    try { const pre = JSON.parse(sessionStorage.getItem('sy_pre') || 'null'); if (pre) { s = Object.assign(s, pre); sessionStorage.removeItem('sy_pre'); } } catch (e) {}
    if (s.name) { $('syName').value = cap(s.name); $('syName').classList.add('ok'); }
    if (s.g) { d.g = s.g; $('syGender').querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.v === s.g))); }
    if (s.age !== undefined && s.age !== '' && s.age !== null) { $('syAge').value = s.age; ageSet = true; ageUI(); }
    if (s.email) { $('syEmail').value = s.email; }
    const wanted = s.adv || s.slug;
    if (wanted) { const a = CFG.adventures.find((x) => x.key === wanted || x.slug === wanted); if (a) { d.adv = a.key; const b = $('syAdv').querySelector(`[data-key="${a.key}"]`); if (b) b.setAttribute('aria-pressed', 'true'); } }
    // Kais 22/10 : plus de monde perso, une ancienne session ne le restaure pas
    if (s.msg) { msg.value = s.msg; $('syMsgCount').textContent = s.msg.length; }
    if (Number.isInteger(s.pack) && CFG.variants[s.pack]) d.pack = s.pack;
    swapImgs();
  }

  /* ---------- histoire sauvegardée sur l'appareil : reprise sans email (voir sy-resume.js) ---------- */
  let photoData = '';
  async function toDataURL(file) {
    try {
      const url = URL.createObjectURL(file);
      const img = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = ko; i.src = url; });
      const k = Math.min(1, 900 / Math.max(img.naturalWidth, img.naturalHeight));
      const c = document.createElement('canvas'); c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
      return c.toDataURL('image/jpeg', 0.82);
    } catch (e) { return ''; }
  }
  function snapshot() {
    return {v: 1, ts: Date.now(), step, name: $('syName').value, g: d.g, age: $('syAge').value, email: $('syEmail').value, adv: d.adv, world: wt.value,
      friend: d.friend, fname: $('syFriendName').value, fg: d.fg, hair: d.hair, pet: d.pet, petType: d.petType, petName: $('syPetName').value,
      passions: d.passions, other: $('syPassionOther').value, color: d.color, occasion: d.occasion, msg: msg.value, details: $('syDetails').value,
      photoPermissionAt: consentOK() ? consentAt : '', fileStamp: d.fileStamp || 0, photo: photoData, stList: stState === 'done' ? stList : [], story: d.story, plot: plData,
      pv: pv.state === 'done' ? {url: pv.url} : null, pack: d.pack};
  }
  let holdPersist = false; // tant que le visiteur n'a pas choisi « reprendre » ou « nouvelle histoire », on ne touche pas à la sauvegarde
  function persist() {
    if (holdPersist || !window.SYResume || !$('syName').value.trim()) return;
    try { localStorage.setItem(SYResume.key, JSON.stringify(snapshot())); }
    catch (e) { try { const s = snapshot(); s.photo = ''; localStorage.setItem(SYResume.key, JSON.stringify(s)); } catch (e2) {} }
  }
  async function resumeFrom(s) {
    consentAt = s.photoPermissionAt || ''; $('syPhotoPermission').checked = !!consentAt;
    const pressed = (wrap, fn) => wrap.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(!!fn(b))));
    const sw = (card, on) => { const b = document.querySelector(`.switch[data-card="${card}"]`); b.setAttribute('aria-checked', String(on)); $(card).classList.toggle('on', on); $(card).querySelector('.card__body').hidden = !on; };
    $('syName').value = s.name || ''; $('syName').classList.toggle('ok', !!s.name);
    d.g = s.g || ''; pressed($('syGender'), (b) => b.dataset.v === d.g);
    if (s.age !== undefined && s.age !== '' && s.age !== null) { $('syAge').value = s.age; ageSet = true; } ageUI();
    $('syEmail').value = s.email || ''; if (validEmail()) leadSent = true;
    wt.value = '';
    d.adv = s.adv || ''; $('syAdv').querySelectorAll('.adv').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.key === d.adv)));
    swapImgs();
    d.friend = !!s.friend; sw('syFriendCard', d.friend); $('syFriendName').value = s.fname || '';
    d.fg = s.fg || ''; pressed($('syFriendGender'), (b) => b.dataset.v === d.fg);
    d.hair = s.hair || ''; pressed($('syHair'), (b) => b.dataset.v === d.hair);
    d.pet = !!s.pet; sw('syPetCard', d.pet); d.petType = s.petType || ''; pressed($('syPetType'), (b) => b.dataset.v === d.petType); $('syPetName').value = s.petName || '';
    d.passions = s.passions || []; pressed($('syPassions'), (b) => d.passions.includes(b.dataset.v)); $('syPassionOther').value = s.other || '';
    d.color = s.color || ''; pressed($('syColor'), (b) => b.dataset.v === d.color);
    d.occasion = s.occasion || ''; pressed($('syOccasion'), (b) => OCC[+b.dataset.i] && OCC[+b.dataset.i][0].replace(/^[^\p{L}]+/u, '') === d.occasion);
    msg.value = s.msg || ''; $('syMsgCount').textContent = msg.value.length; $('syDetails').value = s.details || '';
    if (Number.isInteger(s.pack) && CFG.variants[s.pack]) d.pack = s.pack;
    if (s.photo) {
      try {
        const blob = await (await fetch(s.photo)).blob();
        d.file = new File([blob], 'photo.jpg', {type: 'image/jpeg'}); d.thumb = URL.createObjectURL(blob); d.fileStamp = s.fileStamp || Date.now(); photoData = s.photo;
        $('syThumb').src = d.thumb; $('syPhotoOk').hidden = false; $('syDrop').hidden = true;
      } catch (e) {}
    }
    if (s.pv && s.pv.url && d.file) { pv.state = 'done'; pv.url = s.pv.url; pv.key = pvKey(); }
    evt('sy_resume', {});
    const to = pv.state === 'done' ? PV : stState === 'done' ? 7 : Math.min(s.step || 1, d.file ? 6 : 3);
    go(consentOK() ? to : 3);
  }
  /* si l'image d'aperçu a expiré, on la régénère */
  $('syPvImg').addEventListener('error', () => { if (step === PV && pv.state === 'done' && pv.url) { pv.key = ''; pv.state = ''; go(MK); } });

  const sv = window.SYResume && SYResume.saved();
  holdPersist = !!sv;
  restore();
  const wantResume = new URLSearchParams(location.search).get('resume') === '1';
  const fromMail = (new URLSearchParams(location.search).get('r') || '').replace(/[^a-z0-9]/gi, '');
  { const c = (new URLSearchParams(location.search).get('code') || '').replace(/[^A-Z0-9]/gi, '').toUpperCase().slice(0, 20);
    try { if (c) sessionStorage.setItem('sy_code', c); d.code = c || sessionStorage.getItem('sy_code') || ''; } catch (e) { d.code = c; } }
  { const u = new URL(location.href); u.searchParams.set('step', 1); u.searchParams.delete('resume'); u.searchParams.delete('r'); u.searchParams.delete('code'); history.replaceState({s: 1}, '', u); }
  go(1, false);
  if (fromMail && CFG.api) {  // bouton « Make <name>'s movie » d'un email de relance : histoire rechargée, direct aux packs
    holdPersist = false;
    fetch(CFG.api + '/rs/' + fromMail).then((r) => r.json()).then(async (rec) => {
      if (!rec || !rec.s) throw new Error('rs');
      const s = Object.assign({}, rec.s, {photo: rec.photo || '', pv: rec.preview ? {url: rec.preview} : null});
      await resumeFrom(s); pv.id = fromMail; pv.keep = rec.preview || '';
      if (d.file && pv.state === 'done' && consentOK()) go(PV + 1);
      evt('sy_resume_email', {});
    }).catch(() => { if (sv) SYResume.show(sv, () => { holdPersist = false; resumeFrom(sv); }, () => {}); });
  } else if (sv) {
    const cont = () => { holdPersist = false; resumeFrom(sv); };
    const fresh = () => { try { sessionStorage.removeItem('sy_state'); } catch (e) {} location.href = location.pathname + '?step=1'; };
    if (wantResume) cont(); else SYResume.show(sv, cont, fresh);
  }
})();
